var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgLogoipsum(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logoipsum",
    "data-name": "logoipsum",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 177.78 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logoipsum-4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M38.79,54.79h3V69.5h-3Z",
    style: {
      fill: "#394149"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.53,64.46a5.34,5.34,0,1,1,5.34,5.33A5.28,5.28,0,0,1,43.53,64.46Zm7.66,0a2.32,2.32,0,1,0-2.32,2.38A2.26,2.26,0,0,0,51.19,64.46Z",
    style: {
      fill: "#394149"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.27,59.42V69c0,3.39-2.65,4.82-5.33,4.82a5.15,5.15,0,0,1-4.77-2.44l2.58-1.49A2.3,2.3,0,0,0,61,71.16,2,2,0,0,0,63.32,69v-.93a3.56,3.56,0,0,1-2.94,1.31,5.12,5.12,0,0,1,0-10.24,3.59,3.59,0,0,1,2.94,1.31v-1Zm-2.95,4.84a2.44,2.44,0,1,0-2.44,2.34A2.28,2.28,0,0,0,63.32,64.26Z",
    style: {
      fill: "#394149"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68,64.46a5.34,5.34,0,1,1,5.34,5.33A5.28,5.28,0,0,1,68,64.46Zm7.66,0a2.32,2.32,0,1,0-2.32,2.38A2.26,2.26,0,0,0,75.64,64.46Z",
    style: {
      fill: "#394149"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.07,56.72a1.82,1.82,0,1,1,1.82,1.82A1.83,1.83,0,0,1,80.07,56.72Zm.31,2.7h3V69.5h-3Z",
    style: {
      fill: "#394149"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.46,64.46a5.06,5.06,0,0,1-4.81,5.33,3.83,3.83,0,0,1-3-1.23v5h-3V59.42h3v.95a3.83,3.83,0,0,1,3-1.23A5.06,5.06,0,0,1,96.46,64.46Zm-3,0A2.4,2.4,0,1,0,91,66.92,2.3,2.3,0,0,0,93.44,64.46Z",
    style: {
      fill: "#394149"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.8,66.48c0,2.32-2,3.31-4.2,3.31a4.42,4.42,0,0,1-4.33-2.4l2.62-1.49a1.66,1.66,0,0,0,1.71,1.19c.73,0,1.09-.23,1.09-.63,0-1.11-5-.52-5-4,0-2.2,1.86-3.31,4-3.31a4.43,4.43,0,0,1,3.94,2.16L103,62.69a1.49,1.49,0,0,0-1.36-.89c-.52,0-.84.2-.84.57C100.84,63.52,105.8,62.75,105.8,66.48Z",
    style: {
      fill: "#394149"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.84,59.42V69.5h-3v-.94a3.45,3.45,0,0,1-2.88,1.23c-2,0-3.77-1.45-3.77-4.18V59.42h3v5.75A1.66,1.66,0,0,0,112,67c1.1,0,1.87-.64,1.87-2.07V59.42Z",
    style: {
      fill: "#394149"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.18,63.32V69.5h-3V63.58c0-1-.49-1.66-1.45-1.66s-1.58.71-1.58,1.9V69.5h-3V63.58c0-1-.48-1.66-1.45-1.66s-1.57.71-1.57,1.9V69.5h-3V59.42h3v.93a3.1,3.1,0,0,1,2.7-1.21,3,3,0,0,1,2.64,1.33,3.32,3.32,0,0,1,2.92-1.33C132.67,59.14,134.18,60.8,134.18,63.32Z",
    style: {
      fill: "#394149"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 136.74,
    cy: 57.12,
    r: 2.24,
    style: {
      fill: "#394149"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.74,
    cy: 36.67,
    r: 10.49,
    style: {
      fill: "#394149"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.19,
    cy: 36.67,
    r: 10.49,
    style: {
      fill: "#394149"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.81,
    y: 26.18,
    width: 20.97,
    height: 20.97,
    style: {
      fill: "#394149"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoipsum);
export default __webpack_public_path__ + "static/media/logoipsum.86f3a2304586152005856691bc8c5e2a.svg";
export { ForwardRef as ReactComponent };